import { Controller } from '@hotwired/stimulus';

// クリックで別要素の d-none を外して表示する軽量コントローラ。
// トリガと表示対象が親子関係にない(別 partial にある)ため、対象は
// selector 値で指す。selector 未指定なら data-reveal-target を使う。
export default class extends Controller {
  static values = { selector: String };
  static targets = ['item'];

  show(event) {
    event.preventDefault();
    this.items.forEach((el) => el.classList.remove('d-none'));
  }

  get items() {
    if (this.hasSelectorValue) {
      return Array.from(document.querySelectorAll(this.selectorValue));
    }
    return this.itemTargets;
  }
}
